import { Rnd } from 'react-rnd';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Minus, Square, Maximize2 } from 'lucide-react';
import { Button } from './ui/button';

export const WindowManager = ({ 
  windows, 
  onClose, 
  onFocus, 
  onMinimize, 
  onMaximize,
  onUpdate 
}) => {
  return (
    <AnimatePresence>
      {windows.filter(w => !w.minimized).map((window) => (
        <Rnd
          key={window.id}
          position={{ x: window.x, y: window.y }}
          size={{ width: window.width, height: window.height }}
          onDragStop={(e, d) => {
            onUpdate(window.id, { x: d.x, y: d.y });
          }}
          onResizeStop={(e, direction, ref, delta, position) => {
            onUpdate(window.id, {
              width: ref.offsetWidth,
              height: ref.offsetHeight,
              ...position
            });
          }}
          minWidth={400}
          minHeight={300}
          bounds="parent"
          dragHandleClassName="window-titlebar"
          style={{ zIndex: window.zIndex }}
          onMouseDown={() => onFocus(window.id)}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="w-full h-full glass-panel tech-border rounded-xl overflow-hidden flex flex-col"
          >
            {/* Title Bar */}
            <div className="window-titlebar flex items-center justify-between px-4 py-3 border-b border-border bg-gradient-to-r from-primary/10 to-transparent cursor-move">
              <div className="flex items-center gap-3">
                <div className="flex gap-1.5">
                  <button
                    onClick={() => onClose(window.id)}
                    className="w-3 h-3 rounded-full bg-accent hover:bg-accent-glow transition-colors"
                  />
                  <button
                    onClick={() => onMinimize(window.id)}
                    className="w-3 h-3 rounded-full bg-warning hover:brightness-110 transition-colors"
                  />
                  <button
                    onClick={() => onMaximize(window.id)}
                    className="w-3 h-3 rounded-full bg-success hover:brightness-110 transition-colors"
                  />
                </div>
                <span className="text-sm font-medium glow-text">{window.title}</span>
              </div>
              <div className="flex items-center gap-2">
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-6 w-6 p-0"
                  onClick={() => onMinimize(window.id)}
                >
                  <Minus className="w-3 h-3" />
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-6 w-6 p-0"
                  onClick={() => onMaximize(window.id)}
                >
                  <Maximize2 className="w-3 h-3" />
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-6 w-6 p-0"
                  onClick={() => onClose(window.id)}
                >
                  <X className="w-3 h-3" />
                </Button>
              </div>
            </div>

            {/* Window Content */}
            <div className="flex-1 overflow-auto scrollbar-tech p-6">
              {window.content}
            </div>

            {/* Status Bar */}
            <div className="px-4 py-2 border-t border-border bg-muted/30">
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>ALVIN'S OS • {window.appId}</span>
                <span className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-success animate-pulse-glow" />
                  CONNECTED
                </span>
              </div>
            </div>
          </motion.div>
        </Rnd>
      ))}
    </AnimatePresence>
  );
};

export default WindowManager;